import type { SelectChangeEvent } from "@mui/material/Select";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { Model } from "../../../../../services/api/instances/embeddingsApi/types";
import { AppSelect } from "../../../../../shared/components/AppSelect";
import { AppSelectOption } from "../../../../../shared/components/AppSelect/AppSelectOption";

interface Props {
	models: Model[];
	selectedModel: Model;
	className?: string;
	onChange?: (value: SelectChangeEvent<any>) => void;
}

export const SidebarSelect: FC<Props> = ({
  className,
  onChange,
  models,
  selectedModel,
}) => {
  const { t } = useTranslation();
  return (
    <AppSelect
      className={className}
      displayEmpty
      placeholder={t("embeddings.select_model")}
      itemText={selectedModel?.name}
      value={selectedModel?.name}
      onChange={onChange}
    >
      {models.map(({ model_name, name }) => (
        <AppSelectOption key={model_name} value={name} autoFocus={false}>
          {name}
        </AppSelectOption>
      ))}
    </AppSelect>
  );
};
